import { createI18n } from 'vue-i18n'
import SSOClient from '@kuailu/sso'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  fallbackLocale: 'zh-CN',
  missingWarn: import.meta.env.MODE === 'development',
  fallbackWarn: false
})

export async function setupI18n() {
  try {
    const { locale, messages } = await SSOClient.initLocale()
    if (!Object.keys(messages).length) {
      SSOClient.stateManager.hasError = true
    }
    i18n.global.locale.value = locale
    i18n.global.setLocaleMessage(locale, messages)
    window.$translate = i18n.global.t
    return i18n
  } catch (error) {
    console.error(error)
    window.$translate = i18n.global.t
    return i18n
  }
}

export const $t = i18n.global.t

export default i18n
